import { useLocation } from 'react-router-dom';
import { Divider, Stack } from '@mui/material';
import ContainerPage from '../../components/ContainerPage/ContainerPage';
import Aside from './Aside';
import Content from './Content';

/**
 * Componente que renderiza a página de Prompts
 * @returns {JSX.Element} Componente de página de configurações
 */
export default function AIPrompts() {
  const { pathname } = useLocation();
  const currentPage = pathname.replace('/', '');

  return (
    <ContainerPage title={currentPage}>
      <Stack
        component="main"
        direction="row"
        justifyContent="space-between"
        p={1}
        width="100%"
        sx={{
          bgcolor: '#ffffff',
          boxShadow: '-2px 1px 7px -6px rgba(0, 0, 0, 0.6)',
        }}
      >
        <Aside />

        <Divider orientation="vertical" flexItem />
        <Stack flex={1} px={4} py={2} direction="column" gap={2}>
          <Content />
        </Stack>
      </Stack>
    </ContainerPage>
  );
}
